module.exports = __webpack_public_path__ + "img/logo-tsinghua.df097451.png";